import { registerLocaleData } from "@angular/common";
import localeEsDo from "@angular/common/locales/es-DO";
import { NgModule } from "@angular/core";
import { FiduciariaModule } from "@fiduciaria/fiduciaria.module";
import { UniBreadcrumbModule, UniButtonsModule, UniHeadingModule, UniIconsModule, UniLinkModule } from "@universal-ui";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";

import { FormSharedModule } from "@shared/FormShared/form-shared.module";
import { UserHasPermissionGuard } from "@shared/Guards/user-has-permission.guard";
import { SharedModule } from "@shared/Modules/shared.module";

import { DesktopMenuModule } from "../Header/DesktopMenu/menu.module";
import { HeaderComponent } from "../Header/header.component";
import { HomeEnLineaComponent } from "../Home/home-en-linea/home-en-linea.component";
import { PerfilesModule } from "../Perfiles/perfiles.module";

import { PortalesRoutingModule } from "./portales-routing.module";
import { PortalesComponent } from "./portales.component";

registerLocaleData(localeEsDo);

@NgModule({
  declarations: [HomeEnLineaComponent, PortalesComponent, HeaderComponent],
  imports: [
    PortalesRoutingModule,
    DesktopMenuModule,
    UniBreadcrumbModule,
    UniHeadingModule,
    BsDropdownModule.forRoot(),
    SharedModule,
    UniIconsModule,
    UniLinkModule,
    UniButtonsModule,
    PerfilesModule,
    FiduciariaModule,
    FormSharedModule,
  ],
  providers: [UserHasPermissionGuard],
})
export class PortalesModule {}
